module.exports = __webpack_public_path__ + "static/media/pe.4af9354b.svg";